import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BookingsPageComponent } from './pages/bookings-page/bookings-page.component';

const routes: Routes = [{ path: '', component: BookingsPageComponent, title: 'Réservations' }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BookingsRoutingModule {}
